// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/common/v1/membership_role.proto

/* oxlint-disable */

/** Enum for the role of the user in the organization. */
export const ApiMembershipRole = {
  /** MEMBERSHIP_ROLE_UNSPECIFIED - Unspecified role. */
  MEMBERSHIP_ROLE_UNSPECIFIED: "MEMBERSHIP_ROLE_UNSPECIFIED",
  /**
   * owner - Owner of the organization.
   */
  owner: "owner",
  /**
   * admin - Admin of the organization.
   */
  admin: "admin",
  /**
   * employee - Employee of the organization.
   */
  employee: "employee",
  /**
   * accountant - Accountant of the organization.
   */
  accountant: "accountant",
  /**
   * manager - Manager of the organization.
   */
  manager: "manager",
  /**
   * reporting - Reporting role.
   */
  reporting: "reporting",
} as const;

export type ApiMembershipRole = typeof ApiMembershipRole[keyof typeof ApiMembershipRole];

export namespace ApiMembershipRole {
  export type MEMBERSHIP_ROLE_UNSPECIFIED = typeof ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED;
  export type owner = typeof ApiMembershipRole.owner;
  export type admin = typeof ApiMembershipRole.admin;
  export type employee = typeof ApiMembershipRole.employee;
  export type accountant = typeof ApiMembershipRole.accountant;
  export type manager = typeof ApiMembershipRole.manager;
  export type reporting = typeof ApiMembershipRole.reporting;
}

export function apiMembershipRoleFromJSON(object: any): ApiMembershipRole {
  switch (object) {
    case 0:
    case "MEMBERSHIP_ROLE_UNSPECIFIED":
      return ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED;
    case 1:
    case "owner":
      return ApiMembershipRole.owner;
    case 2:
    case "admin":
      return ApiMembershipRole.admin;
    case 3:
    case "employee":
      return ApiMembershipRole.employee;
    case 4:
    case "accountant":
      return ApiMembershipRole.accountant;
    case 5:
    case "manager":
      return ApiMembershipRole.manager;
    case 6:
    case "reporting":
      return ApiMembershipRole.reporting;
    default:
      return ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED;
  }
}

export function apiMembershipRoleToJSON(object: ApiMembershipRole): string {
  switch (object) {
    case ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED:
      return "MEMBERSHIP_ROLE_UNSPECIFIED";
    case ApiMembershipRole.owner:
      return "owner";
    case ApiMembershipRole.admin:
      return "admin";
    case ApiMembershipRole.employee:
      return "employee";
    case ApiMembershipRole.accountant:
      return "accountant";
    case ApiMembershipRole.manager:
      return "manager";
    case ApiMembershipRole.reporting:
      return "reporting";
    default:
      return "MEMBERSHIP_ROLE_UNSPECIFIED";
  }
}
